<template>
  <v-app id="reset-Password" class="teal">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <h1 class="flex my-4 primary--text">Resetear Clave</h1>
                </div>
                <v-form>
                  <v-text-field
                    append-icon="lock"
                    name="newPass"
                    id="newPass"
                    label="Nueva Clave"
                    type="password"
                    v-model="newPass"
                  ></v-text-field>
                  <v-text-field
                    append-icon="lock"
                    name="rePass"
                    label="Reingresar Clave"
                    id="rePass"
                    type="password"
                    v-model="rePass"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!--                 <v-btn block color="success" @click.prevent="login" :loading="loading">Ingresar</v-btn>-->
                <v-btn
                  block
                  color="success"
                  @click.prevent="resetPass"
                  :loading="loading"
                  >Resetear</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import messages from "@/messages.json";
import axios from "axios";
export default {
  name: "ResetPassword",
  data() {
    return {
      loading: false,
      newPass: "",
      rePass: "",
      tokenToReset: "",
      resp: "",
    };
  },
  mounted() {},
  created() {
    console.log("crea reset pass");
    this.loadResetPassword();
  },
  methods: {
    async loadResetPassword() {
      this.resp = await this.validToken();
      console.log("crea reset pass:resp:" + this.resp);
      this.redirect(this.resp);
    },

    redirect(v) {
      console.log("redirect:" + v);
      if (v != true) {
        // this.loading = true;
        console.log("resdirecciona:" + v);
        setTimeout(() => {
          this.$router.push({
            name: "AccessDenied",
          });
        }, 1000);
      }
    },

    async validToken() {
      this.body = this.$route.query;

      return await axios
        .post("/public/user/validate-token", this.body)
        .then((response) => {
          console.log("resp reset:" + response.data);
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log("error reset::" + error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
        });
    },

    async resetPass() {
      let respo;
      let newPass = this.newPass;
      let rePass = this.rePass;
      if (
        newPass == rePass &&
        newPass != null &&
        rePass != null &&
        newPass != "" &&
        rePass != "" &&
        newPass != undefined &&
        rePass != undefined
      ) {
        let tok = this.$route.query.token;
        let pas = rePass;
        this.body = {
          token: tok,
          password: pas,
        };
        //public
        return await axios
          .put("/public/user/change-password", this.body)
          .then((response) => {
            this.respo = response.data;
            if (this.respo == true) {
              window.getApp.$emit("APP_RESET_PASSWORD_OK");
              this.$router.push({ name: "Login", params: { resetPass: true } });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        window.getApp.$emit("APP_RESET_PASSWORD_DIFFERENT");
      }
    },
  },
};
</script>

<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
